import { PageRef } from 'providers/page-ref';

export type NotePageParams = {
  translationPrefix: 'pinnedNote' | 'setNote';
  currentNote: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export type NotePageResult = {
  success: boolean;
  note?: string;
};

export const INotePage: PageRef<NotePageParams, NotePageResult> = {
  pageName: 'NotePage',
} as PageRef<NotePageParams, NotePageResult>;
